import { lazyWithRetry } from "@/react/lazyWithRetry";
import type { ClientActionDescriptor } from "@/managers/ClientActionRegistry";

// approval.inbox — first glob-discovered client action ported into a
// foundation module's own source tree. The seeded `ir.action` row
// (`approval.action_inbox` in `data/approval_menus.xml`) already
// declares `client_component="approval.inbox"`; the missing piece was
// the registered descriptor — this file IS that piece. Vite's eager
// glob in `clientActionsDiscovery.ts` picks this up at boot.
//
// Lazy-loaded so the bundle stays slim for users who never open
// Approvals. The frozen UX mockup at
// `roadmap/foundation/approval/mockups/approval-inbox-frozen.html`
// (Triage × Dashboard hybrid; ocean-blue accent) is the design
// contract this component implements across Slice 1 (scaffold + live
// data) and Slice 2 (full mockup chrome).

const ApprovalInboxPage = lazyWithRetry(
    () => import("../components/InboxPage").then((m) => ({ default: m.ApprovalInboxPage })),
    "approval.inbox",
);

const plugin: ClientActionDescriptor = {
    key: "approval.inbox",
    component: ApprovalInboxPage,
    paramSchema: "any",
};

export default plugin;
